import { fromJS } from 'immutable';
import { get } from 'lodash';

import {
  SET_USERS_INBOXES,
  REQUEST_SET_MANAGERS_BAWABA,
  SET_COUNT_INBOXES,
} from 'containers/AttributionManager/constants';

const initialState: any = fromJS({
  usersInboxes: [],
  managers: [],
  countInboxes: [],
});

const attributionManagerReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case SET_USERS_INBOXES:
      return state.set('usersInboxes', fromJS(get(action, 'payload', [])));
    case REQUEST_SET_MANAGERS_BAWABA:
      return state.set('managers', fromJS(get(action, 'payload', [])));
    case SET_COUNT_INBOXES:
      return state.set('countInboxes', fromJS(get(action, 'payload', [])));
    default:
      return state;
  }
};

export default attributionManagerReducer;
